import { useRestoreWorkspaceMutation } from '@carboncopyco/data';
import {
  MoreVerticalOutlineIcon,
  RevertOutlineIcon,
} from '@carboncopyco/icons';
import type { Workspace } from '@carboncopyco/types';
import { Button, Dropdown, DropdownItem, notify } from '@carboncopyco/ui';
import { useWorkspaceAnalytics } from '@carboncopyco/utils';
import { useCallback } from 'react';
import { useWorkspacesPage } from './WorkspacesPageContext';

export const WorkspacesPageArchivedTileActions = ({
  workspace,
}: {
  workspace: Workspace;
}) => {
  const { organizationId, removeItem } = useWorkspacesPage();
  const [restoreWorkspace] = useRestoreWorkspaceMutation();
  const { trackWorkspaceClickRestore } = useWorkspaceAnalytics(
    'archived_workspaces'
  );
  const handleRestoreWorkspace = useCallback(() => {
    restoreWorkspace({ organizationId, id: workspace.id })
      .unwrap()
      .then(() => {
        removeItem(String(workspace.id));
        notify.success(
          `Workspace "${workspace?.workspaceName}" was successfully restored`
        );
        trackWorkspaceClickRestore({ workspace });
      })
      .catch(() => notify.error('Error restoring workspace'));
  }, [
    restoreWorkspace,
    organizationId,
    workspace,
    removeItem,
    trackWorkspaceClickRestore,
  ]);

  return (
    <Dropdown
      asChild
      align="start"
      side="bottom"
      triggerElement={
        <Button
          link
          secondary
          icon={<MoreVerticalOutlineIcon />}
        />
      }
    >
      <DropdownItem
        iconLeft={<RevertOutlineIcon />}
        label="Restore"
        onClick={handleRestoreWorkspace}
      />
    </Dropdown>
  );
};
